(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cy-announcement-bar')) {
    customElements.define(
      'cy-announcement-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.setupTicker();

          if (this.hasAttribute('data-design-mode')) return;

          const closeButton = this.querySelector('[data-announcement-close]');
          const storageKey = this.dataset.storageKey;

          try {
            if (storageKey && window.sessionStorage.getItem(storageKey) === 'dismissed') {
              this.hidden = true;
              return;
            }
          } catch (error) {
            // Storage can be unavailable in privacy-restricted browsers.
          }

          closeButton?.addEventListener('click', () => {
            this.hidden = true;
            try {
              if (storageKey) window.sessionStorage.setItem(storageKey, 'dismissed');
            } catch (error) {
              // Dismissal still works for the current page without storage.
            }
          });
        }

        disconnectedCallback() {
          this.tickerResizeObserver?.disconnect();
          if (this.tickerFrame) window.cancelAnimationFrame(this.tickerFrame);
        }

        setupTicker() {
          if (!this.hasAttribute('data-announcement-ticker')) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const viewport = this.querySelector('[data-announcement-ticker-viewport]');
          const track = this.querySelector('[data-announcement-ticker-track]');
          const item = this.querySelector('[data-announcement-ticker-item]');
          if (!viewport || !track || !item) return;

          const textDirection = window.getComputedStyle(this).direction === 'rtl' ? 'rtl' : 'ltr';
          item.style.direction = textDirection;

          const rebuildTicker = () => {
            track.classList.remove('announcement-bar__track--ready');
            track.querySelectorAll('[data-announcement-ticker-clone]').forEach((clone) => clone.remove());

            const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
            const step = item.getBoundingClientRect().width + gap;
            if (!step) return;

            while (track.scrollWidth < viewport.clientWidth + step) {
              const clone = item.cloneNode(true);
              clone.removeAttribute('data-announcement-ticker-item');
              clone.setAttribute('data-announcement-ticker-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('inert', '');
              track.append(clone);
            }

            const tickerStart = textDirection === 'rtl' ? -step : 0;
            const tickerEnd = textDirection === 'rtl' ? 0 : -step;
            track.style.setProperty('--announcement-ticker-start', `${tickerStart}px`);
            track.style.setProperty('--announcement-ticker-end', `${tickerEnd}px`);
            track.style.setProperty('--announcement-ticker-duration', `${Math.max(step / 60, 8)}s`);
            this.tickerFrame = window.requestAnimationFrame(() => {
              track.classList.add('announcement-bar__track--ready');
            });
          };

          rebuildTicker();
          this.tickerResizeObserver = new ResizeObserver(rebuildTicker);
          this.tickerResizeObserver.observe(viewport);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('destination-directory')) {
    class DestinationDirectory extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        if (!window.DestinationSearchEngine) {
          if (!this.waitingForSearchEngine) {
            this.waitingForSearchEngine = true;
            window.addEventListener('destination-search-engine:ready', () => this.connectedCallback(), { once: true });
          }
          return;
        }

        this.initialized = true;
        this.activeFilter = 'ALL';
        this.form =
          this.querySelector('[data-destination-directory-form]') || document.getElementById(this.dataset.searchFormId);
        this.search = this.form?.querySelector('[data-destination-directory-search]');
        this.grid = this.querySelector('[data-destination-directory-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-destination-directory-card]'));
        this.originalCards = [...this.cards];
        this.cardsByHandle = new Map(this.cards.map((card) => [card.dataset.destinationHandle, card]));
        this.index = this.readIndex();
        this.indexByHandle = new Map(this.index.map((destination) => [destination.handle, destination]));
        this.filters = Array.from(this.querySelectorAll('[data-destination-directory-filter]'));
        this.emptyState = this.querySelector('[data-destination-directory-empty]');
        this.resetButton = this.querySelector('[data-destination-directory-reset]');
        this.resultsCount = this.querySelector('[data-destination-directory-results-count]');

        this.search?.addEventListener('input', () => this.update());
        this.form?.addEventListener('submit', (event) => event.preventDefault());
        this.filters.forEach((filter) => {
          filter.addEventListener('click', () => {
            this.activeFilter = filter.dataset.destinationDirectoryFilter;
            this.update();
          });
        });
        this.resetButton?.addEventListener('click', () => {
          this.activeFilter = 'ALL';
          if (this.search) this.search.value = '';
          this.update();
          this.search?.focus();
        });

        this.update();
      }

      readIndex() {
        const source = this.querySelector('[data-destination-index]');
        if (!source) return [];

        try {
          const destinations = JSON.parse(source.textContent);
          const hasValidDestinationShape =
            Array.isArray(destinations) &&
            destinations.every(
              (destination) =>
                destination &&
                typeof destination.handle === 'string' &&
                typeof destination.name === 'string' &&
                typeof destination.type === 'string' &&
                (destination.aliases === null || Array.isArray(destination.aliases))
            );

          if (!hasValidDestinationShape) {
            throw new Error('Destination index does not match the shared search data structure.');
          }
          return destinations;
        } catch (error) {
          console.error('Destination directory index could not be initialized.', error);
          return [];
        }
      }

      matchesActiveFilter(destination, card) {
        if (this.activeFilter === 'ALL') return true;
        const destinationType = destination?.type || card.dataset.destinationType;
        return destinationType === this.activeFilter;
      }

      setCardVisibility(card, visible) {
        card.hidden = !visible;
        card.classList.toggle('is-hidden', !visible);
      }

      updateResultsCount(visibleCount, hasActiveCriteria) {
        if (!this.resultsCount) return;

        if (visibleCount === 0) {
          this.resultsCount.textContent = this.resultsCount.dataset.resultsCountEmpty || '';
        } else if (hasActiveCriteria) {
          const template = this.resultsCount.dataset.resultsCountFilteredTemplate || '';
          this.resultsCount.textContent = template
            .replace('[visible]', String(visibleCount))
            .replace('[total]', String(this.cards.length));
        } else {
          const template = this.resultsCount.dataset.resultsCountAllTemplate || '';
          this.resultsCount.textContent = template.replace('[count]', String(this.cards.length));
        }

        this.resultsCount.hidden = false;
      }

      update() {
        const query = this.search ? window.DestinationSearchEngine.normalize(this.search.value) : '';
        let visibleCount = 0;

        this.filters.forEach((filter) => {
          const selected = filter.dataset.destinationDirectoryFilter === this.activeFilter;
          filter.classList.toggle('is-active', selected);
          filter.setAttribute('aria-pressed', String(selected));
        });

        this.cards.forEach((card) => this.setCardVisibility(card, false));

        if (query) {
          const directMatches = window.DestinationSearchEngine.directMatches(this.index, query);
          directMatches.forEach(({ destination }) => {
            const card = this.cardsByHandle.get(destination.handle);
            if (!card || !this.matchesActiveFilter(destination, card)) return;

            this.setCardVisibility(card, true);
            this.grid.append(card);
            visibleCount += 1;
          });
        } else {
          this.originalCards.forEach((card) => {
            const destination = this.indexByHandle.get(card.dataset.destinationHandle);
            const visible = this.matchesActiveFilter(destination, card);

            this.setCardVisibility(card, visible);
            this.grid.append(card);
            if (visible) visibleCount += 1;
          });
        }

        const hasActiveCriteria = Boolean(query) || this.activeFilter !== 'ALL';
        this.updateResultsCount(visibleCount, hasActiveCriteria);
        this.emptyState.hidden = visibleCount !== 0;
      }
    }

    customElements.define('destination-directory', DestinationDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('connected-countdown')) {
    customElements.define('connected-countdown', class ConnectedCountdown extends HTMLElement {
      connectedCallback() {
        this.endAt = Date.parse(this.dataset.endAt);
        if (Number.isNaN(this.endAt)) return;
        this.nodes = {
          days: this.querySelector('[data-countdown-days]'),
          hours: this.querySelector('[data-countdown-hours]'),
          minutes: this.querySelector('[data-countdown-minutes]'),
          seconds: this.querySelector('[data-countdown-seconds]')
        };
        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() { window.clearInterval(this.timer); }

      update() {
        const remaining = Math.max(0, this.endAt - Date.now());
        if (remaining <= 0) { this.expire(); return; }
        const showDays = this.dataset.showDays === 'true';
        const showHours = this.dataset.showHours === 'true';
        const showMinutes = this.dataset.showMinutes === 'true';
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor(remaining / 3600000) % (showDays ? 24 : Number.MAX_SAFE_INTEGER);
        const minutes = Math.floor(remaining / 60000) % (showHours ? 60 : Number.MAX_SAFE_INTEGER);
        const seconds = Math.floor(remaining / 1000) % (showMinutes ? 60 : Number.MAX_SAFE_INTEGER);
        this.setValue('days', days);
        this.setValue('hours', hours);
        this.setValue('minutes', minutes);
        this.setValue('seconds', seconds);
      }

      setValue(unit, value) { if (this.nodes[unit]) this.nodes[unit].textContent = String(value).padStart(2, '0'); }

      expire() {
        window.clearInterval(this.timer);
        if (this.dataset.expiry === 'hide') { this.closest('.countdown-section')?.setAttribute('hidden', ''); return; }
        if (this.dataset.expiry === 'message') {
          this.querySelector('.countdown__units')?.setAttribute('hidden', '');
          const message = this.querySelector('[data-countdown-message]');
          if (message) { message.textContent = this.dataset.expiredMessage; message.hidden = false; }
        }
        if (this.dataset.expiry === 'zero') Object.keys(this.nodes).forEach((unit) => this.setValue(unit, 0));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
  class HelpCenter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.search = this.querySelector('[data-help-search]');
      this.clear = this.querySelector('[data-help-clear]');
      this.categories = [...this.querySelectorAll('[data-help-category]')];
      this.items = [...this.querySelectorAll('[data-help-faq]')];
      this.empty = this.querySelector('[data-help-no-results]');
      this.setupGuides = this.querySelector('[data-help-setup-guides]');
      this.setupTabs = [...this.querySelectorAll('[data-help-setup-tab]')];
      this.setupPanels = [...this.querySelectorAll('[data-help-setup-panel]')];
      this.selectedCategory = this.dataset.defaultCategory;

      this.search?.addEventListener('input', () => this.refresh());
      this.clear?.addEventListener('click', () => {
        this.search.value = '';
        this.search.focus();
        this.refresh();
      });
      this.categories.forEach((category) =>
        category.addEventListener('click', () => {
          this.selectedCategory = category.dataset.helpCategory;
          this.search.value = '';
          this.refresh();
        })
      );
      this.setupTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectSetupTab(tab.dataset.helpSetupTab));
        tab.addEventListener('keydown', (event) => this.handleSetupTabKeydown(event, index));
      });
      if (this.querySelector('[data-sticky-search-origin]')) {
        window.dispatchEvent(new CustomEvent('sticky-search:available'));
      }
      this.refresh();
    }

    selectSetupTab(name, moveFocus = false) {
      this.setupTabs.forEach((tab) => {
        const selected = tab.dataset.helpSetupTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) tab.focus();
      });
      this.setupPanels.forEach((panel) => {
        panel.hidden = panel.dataset.helpSetupPanel !== name;
      });
    }

    handleSetupTabKeydown(event, index) {
      const lastIndex = this.setupTabs.length - 1;
      const isRtl = window.getComputedStyle(this).direction === 'rtl';
      let nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = isRtl ? (index === 0 ? lastIndex : index - 1) : (index === lastIndex ? 0 : index + 1);
      if (event.key === 'ArrowLeft') nextIndex = isRtl ? (index === lastIndex ? 0 : index + 1) : (index === 0 ? lastIndex : index - 1);
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = lastIndex;
      if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      this.selectSetupTab(this.setupTabs[nextIndex].dataset.helpSetupTab, true);
    }

    normalize(value) {
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    refresh() {
      const query = this.normalize(this.search?.value);
      const terms = query.split(' ').filter(Boolean);
      const isSearching = terms.length > 0;
      const selected = this.categories.find((category) => category.dataset.helpCategory === this.selectedCategory);

      this.categories.forEach((category) => {
        const active = !isSearching && category === selected;
        category.classList.toggle('is-active', active);
        category.setAttribute('aria-pressed', String(active));
      });

      let visible = 0;
      this.items.forEach((item) => {
        const matchesSearch = terms.every((term) => this.normalize(item.dataset.helpSearchText).includes(term));
        const matchesCategory = isSearching || item.dataset.helpCategoryHandle === this.selectedCategory;
        const matches = matchesSearch && matchesCategory;
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      if (this.clear) this.clear.hidden = !isSearching;
      if (this.setupGuides) {
        this.setupGuides.hidden = isSearching || this.selectedCategory !== this.setupGuides.dataset.helpCategoryHandle;
      }
      if (this.empty) {
        this.empty.hidden = visible !== 0;
        this.empty.textContent = this.dataset.noResults;
      }
    }
  }

  if (!customElements.get('help-center')) {
    customElements.define('help-center', HelpCenter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-storefront-password-toggle]');
    if (!toggle) return;

    const input = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!input) return;

    const isVisible = input.type === 'text';
    input.type = isVisible ? 'password' : 'text';
    toggle.setAttribute('aria-pressed', String(!isVisible));
    toggle.querySelector('[data-storefront-password-toggle-label]').textContent = isVisible
      ? toggle.dataset.showLabel
      : toggle.dataset.hideLabel;
  });

  const focusPasswordError = () => {
    const error = document.querySelector('.password-page__error');
    if (error) error.focus();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusPasswordError, { once: true });
  } else {
    focusPasswordError();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marketing-popup')) {
    customElements.define('marketing-popup', class MarketingPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.storageKey = `connected-you-popup-${this.dataset.sectionId}`;
        this.closeButton = this.querySelector('[data-popup-close]');
        this.closeButton?.addEventListener('click', () => this.close(true));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog && this.dataset.overlayClose === 'true') this.close(true);
        });
        this.dialog.addEventListener('cancel', (event) => {
          if (this.dataset.escapeClose !== 'true') event.preventDefault();
          else this.remember();
        });
        document.querySelectorAll(`[data-popup-open="${this.dataset.sectionId}"]`).forEach((trigger) => {
          trigger.addEventListener('click', (event) => { event.preventDefault(); this.open(true); });
        });
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        if (this.dataset.designMode !== 'true' && this.dataset.enabled === 'true' && this.canOpen()) this.prepareTrigger();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('mouseout', this.onExit);
        window.clearTimeout(this.timer);
      }

      onSectionSelect = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open(true);
      };

      prepareTrigger() {
        if (this.dataset.trigger === 'delay') this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay));
        if (this.dataset.trigger === 'scroll') window.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.dataset.trigger === 'exit') document.addEventListener('mouseout', this.onExit);
      }

      onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && (window.scrollY / scrollable) * 100 >= Number(this.dataset.scroll)) {
          window.removeEventListener('scroll', this.onScroll);
          this.open();
        }
      };

      onExit = (event) => {
        if (event.clientY <= 0 && !event.relatedTarget) {
          document.removeEventListener('mouseout', this.onExit);
          this.open();
        }
      };

      canOpen() {
        if (this.dataset.frequency === 'always') return true;
        let saved;
        try { saved = Number(localStorage.getItem(this.storageKey) || sessionStorage.getItem(this.storageKey)); } catch (error) { return true; }
        if (!saved) return true;
        if (this.dataset.frequency === 'session') return false;
        const days = this.dataset.frequency === '7_days' ? 7 : 30;
        return Date.now() - saved > days * 86400000;
      }

      open(force = false) {
        if (!force && !this.canOpen()) return;
        if (!force) this.remember();
        if (!this.dialog.open) this.dialog.showModal();
      }

      close(remember = false) {
        if (remember) this.remember();
        if (this.dialog.open) this.dialog.close();
      }

      remember() {
        if (this.dataset.frequency === 'always') return;
        try {
          const storage = this.dataset.frequency === 'session' ? sessionStorage : localStorage;
          storage.setItem(this.storageKey, String(Date.now()));
        } catch (error) { /* Storage can be unavailable in privacy modes. */ }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-grid-motion')) {
    customElements.define('testimonial-grid-motion', class TestimonialGridMotion extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-grid-viewport]');
        this.sequence = this.querySelector('[data-grid-sequence]');
        if (!this.viewport || !this.sequence) return;

        this.measure = this.measure.bind(this);
        this.scheduleMeasurement = this.scheduleMeasurement.bind(this);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.scheduleMeasurement);
          this.resizeObserver.observe(this.sequence);
        }

        window.addEventListener('resize', this.scheduleMeasurement, { passive: true });
        this.scheduleMeasurement();
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.scheduleMeasurement();
        });
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleMeasurement);
        if (this.measurementFrame) cancelAnimationFrame(this.measurementFrame);
      }

      scheduleMeasurement() {
        if (this.measurementFrame) cancelAnimationFrame(this.measurementFrame);
        this.measurementFrame = requestAnimationFrame(this.measure);
      }

      measure() {
        this.measurementFrame = null;
        const cards = Array.from(this.sequence.children);
        if (!cards.length) return;

        const sequenceRect = this.sequence.getBoundingClientRect();
        const rows = [];

        cards.forEach((card) => {
          const cardRect = card.getBoundingClientRect();
          const top = Math.round(cardRect.top - sequenceRect.top);
          let row = rows.find((entry) => Math.abs(entry.top - top) <= 1);

          if (!row) {
            row = { top, bottom: 0 };
            rows.push(row);
          }

          row.bottom = Math.max(row.bottom, cardRect.bottom - sequenceRect.top);
        });

        rows.sort((first, second) => first.top - second.top);
        const requestedRows = Number.parseInt(this.dataset.visibleRows, 10);
        let viewportHeight = sequenceRect.height;

        if (Number.isFinite(requestedRows) && requestedRows > 0 && requestedRows < rows.length) {
          const paddingBottom = Number.parseFloat(getComputedStyle(this.sequence).paddingBottom) || 0;
          viewportHeight = rows[requestedRows - 1].bottom + paddingBottom;
        }

        this.style.setProperty('--testimonials-grid-viewport-height', `${Math.ceil(viewportHeight)}px`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
